import React, { createContext, useContext, useEffect, useState } from "react";
import { UseQueryResult } from "react-query";
import { EventType } from "src/components/useUndoState";
import {
  ProtocolLI,
  ProtocolType,
} from "src/modules/fithub-shared/interfaces/protocol";
import api from "src/rest/api";

interface PlanContextProps {
  plan: {
    selected: ProtocolType | null;
    setProtocol(plan: ProtocolType | null): void;
    update(plan: ProtocolType): void;
    unselect(): void;
    history?: EventType<ProtocolType>;
    modified?: boolean;
  };
  save(before?: () => void): Promise<void>;
  reloadList: () => void;
}

const PlanContext = createContext<PlanContextProps | undefined>(undefined);

const PlanContextProvider = ({
  children,
  list,
}: {
  children?: React.ReactNode;
  list: UseQueryResult<ProtocolLI[], unknown>;
}) => {
  const [protocol, setProtocol] = useState<ProtocolType | null>(null);
  const [modified, setModified] = useState(false);

  useEffect(() => {
    console.log("Alguma coisa afetou o PlanContextProvider");
  }, []);

  async function saveProtocol(before?: () => void) {
    if (before) await before();

    const raw: ProtocolType = { ...protocol } as ProtocolType;

    return api
      .post("/protocols/save", raw)
      .then(() => {
        setModified(false);
        list.refetch();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function updateProtocol(modified: ProtocolType) {
    setModified(true);
    setProtocol(modified);
  }

  const unselectProtocol = () => {
    setProtocol(null);
  };

  return (
    <PlanContext.Provider
      value={{
        plan: {
          selected: protocol,
          setProtocol: setProtocol,
          unselect: unselectProtocol,
          update: updateProtocol,
          //history: pEvents,
          modified,
        },
        save: saveProtocol,
        reloadList: list.refetch,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
};

const usePlan = () => {
  const context = useContext(PlanContext);
  if (!context) {
    throw new Error("usePlan must be used within a PlanContextProvider");
  }
  return context;
};

export { PlanContextProvider, usePlan };
